import React from 'react';
import { Head } from '@inertiajs/react';
import Navigation from '@/components/Navigation';

export default function MainLayout({ children, title, user }) {
  return (
    <>
      <Head title={title || 'Rezy - Find Assisted Living & Memory Care Communities'} />
      <div className="min-h-screen bg-background">
        {/* Navigation */}
        <Navigation user={user}/>

        {/* Main Content */}
        <main>
          {children}
        </main>
      </div>
    </>
  );
}
